import {
  useIsMobile,
  WSElement,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import queryString from "qs";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { Tabs } from "../../../../components/Tabs";
import { BulkImportCollaborators } from "../BulkImportCollaborators";
import { BulkImportPayables } from "../BulkImportPayables";
import styles from "./styles.module.scss";

import { useUrlQueryFilters } from "../../../../utils/router";
import { useAccountAccess } from "../../../../v3/hooks/useAccountAccess";
import { FilterSelectYear } from "../../components/FilterSelectYear";
import {
  BULK_IMPORT_CONTRACTORS_BATCHES,
  BULK_IMPORT_PAYABLES_BATCHES,
  useGoToContractorImportStart,
  useGoToPayablesImportStart
} from "../../paths";
import { BulkBatchesFilters } from "../../services/types";

export function BulkImports() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const queries: { year?: string } = queryString.parse(location.search, {
    ignoreQueryPrefix: true
  });
  const { filters } = useUrlQueryFilters<BulkBatchesFilters>({
    year: queries.year
  });
  const { hasScope } = useAccountAccess();

  const goToContractorImportStart = useGoToContractorImportStart();
  const goToPayablesImportStart = useGoToPayablesImportStart();

  // TODO

  return (
    <WSPage>
      <WSPageToolbar
        title="Bulk imports"
        titleAfter={<FilterSelectYear defaultYear={Number(filters.year)} />}
        actions={[
          {
            hidden: !hasScope("payments.payable"),
            name: "importPayables",
            buttonKind: "Primary",
            label: "Import payables & deductions",
            onClick: () => {
              goToPayablesImportStart();
            }
          },
          {
            hidden: !hasScope("payments.payee"),
            name: "importContractors",
            label: "Import contractors",
            buttonKind: "Secondary",
            onClick: () => {
              goToContractorImportStart();
            }
          }
        ]}
      />

      <Tabs
        tabs={[
          ...(hasScope("payments.payable")
            ? [
                {
                  path: BULK_IMPORT_PAYABLES_BATCHES,
                  label: "Payables & deductions",
                  params: { year: filters.year }
                }
              ]
            : []),
          ...(hasScope("payments.payee")
            ? [
                {
                  path: BULK_IMPORT_CONTRACTORS_BATCHES,
                  label: "Contractors",
                  params: { year: filters.year }
                }
              ]
            : [])
        ]}
      />
      <WSElement mt={isMobile ? "XL" : "L"} className={styles.wrapper}>
        <Switch>
          {hasScope("payments.payable") ? (
            <Route
              path={BULK_IMPORT_PAYABLES_BATCHES}
              component={BulkImportPayables}
            />
          ) : null}
          {hasScope("payments.payee") ? (
            <Route
              path={BULK_IMPORT_CONTRACTORS_BATCHES}
              component={BulkImportCollaborators}
            />
          ) : null}
          <Redirect
            from="*"
            to={`${BULK_IMPORT_PAYABLES_BATCHES}?year=${new Date().getFullYear()}`}
          />
        </Switch>
      </WSElement>
    </WSPage>
  );
}
